import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./Legal.css";
import { useEffect } from "react";

function About() {
 


 useEffect(() => {
  window.scrollTo(0, 0);
 }, []);
 return (
  <div className="legal-page about-page">
   <Helmet>
    <title>About | SportingHip</title>
    <meta
     name="description"
     content="SportingHip helps people find local sports programs and helps organizations keep their listings clear, accurate, and up to date."
    />
   </Helmet>

   <div className="legal-back-corner">
    <Link to="/">← Back to directory</Link>
   </div>

   <main className="legal-container about-container">
    <section className="about-hero">
     <span className="about-eyebrow">About SportingHip</span>

     <h1 className="legal-title">
      Helping people find local sports programs.
     </h1>

     <p className="about-hero-text">
      SportingHip is a sports directory built to make it easier for
      players, parents, and teams to discover local leagues, clubs, camps,
      classes, tournaments, and programs.
     </p>
    </section>

    <section className="about-card">
     <h2>Why SportingHip exists</h2>
     <p>
      Sports programs are often spread across websites, flyers, Facebook
      posts, registration portals, and social media pages. Sometimes the
      information changes by season, and it can be hard to know what is
      currently active.
     </p>

     <p>
      SportingHip helps organize that information in one clean place while
      still sending visitors back to the official organization website or
      registration page for the latest details.
     </p>
    </section>

    <section className="about-grid">
     <div className="about-info-box">
      <h3>For players & families</h3>
      <ul>
       <li>Browse sports by location and program type</li>
       <li>Find leagues, clubs, camps, classes, and tournaments</li>
       <li>See useful details like ages, venues, and registration info</li>
       <li>Go directly to the official source when ready</li>
      </ul>
     </div>

     <div className="about-info-box">
      <h3>For organizations</h3>
      <ul>
       <li>Get discovered by local players and teams</li>
       <li>Send program updates when details change</li>
       <li>Help visitors find the correct registration information</li>
       <li>Try our league management demo for schedules and teams</li>
      </ul>
     </div>
    </section>

    <section className="about-card about-contact-card">
     <h2>Have a program update?</h2>
      <p>
       Need your organization listed or need information updated? Send over your leagues,
       camps, classes, tournaments, registration links, or seasonal details, and we’ll
       do our best to keep the listing clear and accurate.
      </p>


     <a
      className="about-email-btn"
      href="mailto:hello@sportinghip.com?subject=SportingHip Program Update"
     >
      Email SportingHip
     </a>
    </section>

    <section className="about-card">
     <h2>What’s next</h2>
     <p>
      We’re building tools for schedules, standings, teams, rosters,
      player stats, public pages, and game updates so sports organizations
      can manage more of their league from one place.
     </p>

     <Link to="/demo" className="about-secondary-link">
      Try the league management demo →
     </Link>
    </section>
   </main>


  </div>
 );
}

export default About;